import React from 'react';
import socket, { reconnectToChat } from './chat';
import { useLogin } from 'redux/reducers/gl_auth_reducer/selectors';
import store from 'redux/store';
import { getSessionId } from 'utils/session';
import { useChatConnect } from './chat/selectors';

interface ISocketConnections {
  chat: typeof socket;
}

export const SocketContext = React.createContext<ISocketConnections | null>(
  null
);

interface ISocketioProviderProps {
  // children: React.ReactElement;
}

const SocketioProvider = ({}: ISocketioProviderProps) => {
  const isLogin = useLogin();
  // const [ready, setReady] = React.useState(true);
  const connect = useChatConnect();

  React.useEffect(() => {
    // setReady(false);
    // console.log('INNNNNNNNNNNNNNNNNNNN', isLogin);
    reconnectToChat();

    // if (flagRef.current) {
    //   console.log('INNNNNNNNNNNNNNNNNNNN', isLogin);
    //   reconnectToChat();
    // } else {
    //   flagRef.current = true;
    // }
    // setTimeout(() => {
    //   setReady(true);
    // }, 400);
  }, [isLogin]);

  //   React.useEffect(() => {
  //     // here we san use socket events and listeners
  //     return () => {
  //       socket.disconnect();
  //     }; //cleanup
  //   }, []);

  return null;
  // return (
  //   <SocketContext.Provider
  //     // value={{
  //     //   chat: socket,
  //     // }}
  //   >
  //     {connect && children}
  //   </SocketContext.Provider>
  // );
};

// export const useSocket = () => {
//   return React.useContext(SocketContext);
// };

export default React.memo(SocketioProvider);
